export default {
  // Login page
  Username: 'Username',
  Password: 'Password',
  'Logging in, please wait': 'Logging in, please wait',
  'Log in': 'Log in',
  'Log in with single sign-on': 'Log in with single sign-on',
  'You are being safely logged out, please wait': 'You are being safely logged out, please wait',
  Back: 'Back',

  // Sidebar
  Department: 'Department',
  'Log out': 'Log out',
  'Your citizens': 'Your citizens',
  'Edit information': 'Edit information',
  'Lock screen': 'Lock screen',
  'Add new task': 'Add new task',

  // Group list
  'Select a group': 'Select a group',

  // Member list
  'No name': 'No name',

  // Member show
  Day: 'Day',
  Week: 'Week',
  'Time frame': 'Time frame',
  'No click in time frame': 'No click in time frame',
  'Overdue timer': 'Overdue timer',
  'Click in time frame': 'Click in time frame',
  'Click outside time frame': 'Click outside time frame',
  'Approved deviation': 'Approved deviation',
  'This citizen has no tasks': 'This citizen has no tasks',
  'Hide deviations': 'Hide deviations',
  'Show deviations': 'Show deviations',
  'Show week': 'Show week',
  'Show today': 'Show today',
  'Approving deviation': 'Approving deviation',
  'Approving deviation with note': 'Approving deviation with note',
  'Deviation approved': 'Deviation approved',
  'Deviation approved with note': 'Deviation approved with note',
  'Approve deviation': 'Approve deviation',
  'Note (optional)': 'Note (optional)',
  'Optional text': 'Optional text',
  Calendar: 'Calendar',
  Appearance: 'Appearance',
  Full: 'Full',
  Compact: 'Compact',

  // Member edit
  'First name': 'First name',
  'Last name': 'Last name',
  'Save changes': 'Save changes',

  // Deviation info
  Approving: 'Approving',
  Cancel: 'Cancel',
  Confirm: 'Confirm',
  Approve: 'Approve',
  'X deviations in total': '{count} deviations in total',

  // Task create / edit
  Timer: 'Timer',
  Schedule: 'Schedule',
  'On demand': 'On demand',
  Braden: 'Braden',
  minutes: 'minutes',
  hour: 'hour',
  hours: 'hours',
  'MAC address already in use': 'MAC address already in use',
  'Button ID not found': 'Button ID not found',
  'Delete task': 'Delete task',
  'This can not be revereted': 'This can not be revereted',
  Delete: 'Delete',
  Edit: 'Edit',
  'Edit task': 'Edit task',
  'Create new task': 'Create new task',
  Name: 'Name',
  Buttons: 'Buttons',
  Type: 'Type',
  Time: 'Time',
  'Give the task a name': 'Give the task a name',
  Continue: 'Continue',
  'Enter button ID': 'Enter button ID',
  'Enter MAC address': 'Enter MAC address',
  'Use MAC address': 'Use MAC address',
  'Use button ID': 'Use button ID',
  'Add button': 'Add button',
  'Select a type': 'Select a type',
  Ok: 'Ok',
  Close: 'Close',
  'Select time': 'Select time',
  Occurrence: 'Occurrence',
  'Every day': 'Every day',
  'Specific weekdays': 'Specific weekdays',
  'Add time': 'Add time',
  'Time tolerance in minutes': 'Time tolerance in minutes',
  'On demand requires no planning': 'On demand requires no planning',
  'How much time should pass between each click': 'How much time should pass between each click',
  'When should the timer start': 'When should the timer start',
  Now: 'Now',
  'Set a time': 'Set a time',
  'Enter Braden Score': 'Enter Braden Score',
  'Add task': 'Add task',
  Remove: 'Remove',
  'Select days': 'Select days',
  'Times can not overlap': 'Times can not overlap',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  'Task added': 'Task added',
  'Task updated': 'Task updated',
  'Task deleted': 'Task deleted',
  'Changes saved': 'Changes saved',
  'Allow clicks outside of schedule?': 'Allow clicks outside of schedule?',
  'Confirm time tolerance': 'Confirm time tolerance',
  'Is the current time tolerance of X minutes correct?': 'Is the current time tolerance of {time} minutes correct?',

  // Locked screen: Ecrã bloqueado
  'You should complete the task {{task}} in {{time}}': 'You should complete the task {{task}} in {{time}}',
  'You should complete the task {{task}} within {{time}}': 'You should complete the task {{task}} within {{time}}',
  'You should complete the task {{task}} now': 'You should complete the task {{task}} now',
  'The task {{task}} is overdue by {{time}}, complete as soon as possible': 'The task {{task}} is overdue by {{time}}, complete as soon as possible',
  'Remember to complete the task {{task}} in {{time}}': 'Remember to complete the task {{task}} in {{time}}',

  'Citizen-screen': 'Citizen-screen',
  'Add new Citizen': 'Add new Citizen',
  'Or choose Citizen from list': 'Or choose Citizen from list',
  'It is time to': 'It is time to',
  'Nothing to do - Good job!': 'Nothing to do - Good job!',
  'Within the next minutes you need to remember {{task}} it would be best to do at {{time}}': 'Within the next minutes you need to remember {{task}} it would be best to do at {{time}}',
  "It's time to {{task}}": "It's time to {{task}}",
  Version: 'Version',
  'Sharing of your location is needed to use the app correctly': 'Sharing of your location is needed to use the app correctly',

  // MarkerInfoModal
  Fulfilled: 'Fulfilled',
  Deviation: 'Deviation',
  'Approved by': 'Approved by',
  'Note by': 'Note by',
  'Add note': 'Add note',
  Note: 'Note',
  'Adding note': 'Adding note',

  // Notifications
  Notifications: 'Notifications',
  'Phone numbers': 'Phone numbers',
  'Phone number': 'Phone number',
  'Deactivate all': 'Deactivate all',
  'New number': 'New number',
  Active: 'Active',
  Inactive: 'Inactive',
  Activate: 'Activate',
  Deactivate: 'Deactivate',
  'Edit number': 'Edit number',
  'Add number': 'Add number',
  'Plan type': 'Plan type',
  Simple: 'Simple',
  Advanced: 'Advanced',
  'Simple plan explainer': 'The simple plan type, works for specific days between two times, eg. every day between 08:00 - 16.00',
  'Choose time': 'Choose time',
  From: 'From',
  To: 'To',
  Create: 'Create',
  'Advanced plan explainer': 'The advanced plan type, allows for setup for all days of the week, and allows for multiple times per day.',
  Times: 'Times',
  'Phone number is required': 'Phone number is required',
  'Phone number is invalid': 'Phone number is invalid',
  'Active for notifications': 'Active for notifications',
  'Toggle task notifications': 'Toggle task notifications',
  'Put on pause': 'Put on pause',
  'Sort by deviations': 'Sort by deviations',
  'Sort by name': 'Sort by name',
  Sort: 'Sort',
  'Your active citizens': 'Your active citizens',
  'Your inactive citizens': 'Your inactive citizens',
};
